module.exports = __webpack_public_path__ + "static/media/logo.32758528.png";